// React + Tailwind version of your Zoho-based layout with content from JSON

import React from "react";
import { useNavigate } from "react-router-dom";
import staffing from '../../mainSection/Social_media/staffing.jpg'
import offShore from '../../../assests/unnamed.jpg'
import hire from '../../mainSection/Social_media/hireTTeam.jpg'


const servicesData = [
  {
    id: 1,
    title: "Contractual/Flexible Workforce",
    number: "01",
    description1: "Need a clutch player for your project, but just for a short run? TekIT’s got you. Our Contractual workforce Services are built to flex—plug in pro-level talent right when your project needs that boost.",
    description2: "We make it easy to level up fast, meet deadlines, and keep things moving without missing a beat. Whether you’re filling a skills gap or just need some extra hands on deck, TekIT lets you tap into top-tier expertise, only when you need it. No strings, just results.",
    description3: "",
    description4: "",
    bullets: [
      "Screen replacement",
      "Button and port repairs",
      "Battery replacements",
      "Cooling system maintenance"
    ],
    image: staffing
  },
  // {
  //     id: 2,
  //     title: "Permanent Staffing",
  //     number: "02",
  //     description1:"Looking for Permanent resources who can work explicitly for you?",
  //     description2:"Our Permanent Staffing services address the complex workforce challenges which organizations face today. TekIT’s exposure to cross-sectional talent coupled with sourcing expertise can be leveraged to meet the organization’s permanent staffing requirements.",
  //     description3:"TekIT offer organizations with needed applicants for long-term employment based on particular applicant qualifications. We approach recruiting with a mix of time-honoured, best practices and resourceful engagement with today’s connected and global economy. We collect the best fit applicants on the basis of salary, cultural resonance, job description & experience.",
  //     description4:"We offer both C2C & C2H Model.",
  //     bullets: [
  //         "OS repair and re-installation",
  //         "Virus and malware removal",
  //         "Data recovery"
  //     ],
  //     image: "https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1272.webp"
  // },
  {
    id: 2,
    title: "Offshore Technology Center",
    number: "02",
    description1: "TekIT’s Offshore Technology Center (OTC) serves as a dedicated hub where skilled IT professionals deliver high-quality software development and IT solutions remotely. By leveraging this center,",
    description2: "TekIT provides clients with access to global expertise, cost-effective resources, and flexible staffing options tailored to project needs and time zones.",
    description3: "The OTC model enables businesses to scale their teams efficiently while maintaining control over operations, ensuring timely delivery and innovation across diverse technology domains",
    description4: "",
    bullets: [
      "Network security concerns",
      "IP address conflicts",
      "Router and modem configuration",
      "Network troubleshooting"
    ],
    image: offShore
  },
  {
    id: 3,
    title: "Engage a Team",
    number: "03",
    description1: "When you have a project in mind or in hand which require different domain experts then you can opt for ‘Hire a Team’, where Team can be a combination of Frontend Developer, Backend Developer, Mobile App Developers, Project Manager, Business Analyst, DBA, QA and support specialist.",
    description2: "At TekIT, we empower your business to scale by providing virtual teams of skilled developers proficient in a wide range of technologies and specialties.",
    description3: "You simply manage your remote development team according to your requirements, while we ensure you receive exceptional results and seamless project delivery",
    description4: "",
    bullets: [
      "Network security concerns",
      "IP address conflicts",
      "Router and modem configuration",
      "Network troubleshooting"
    ],
    image: hire
  }
];

// const steps = [
//   {
//     number: "1",
//     title: "SHARE THE REQUIREMENT",
//     desc: "Understanding client requirements is key when it comes to staffing solutions...",
//     color: "bg-purple-500",
//     iconBg: "bg-purple-500",
//   },
//   {
//     number: "2",
//     title: "SHORTLIST THE MOST SUITABLE CANDIDATE",
//     desc: "Our staffing experts will shortlist the perfect candidates for your project...",
//     color: "bg-blue-500",
//     iconBg: "bg-blue-500",
//   },
//   {
//     number: "3",
//     title: "ARRANGE THE INTERVIEW",
//     desc: "We will line up interviews to select the one who is the most suitable...",
//     color: "bg-green-400",
//     iconBg: "bg-green-400",
//   },
//   {
//     number: "4",
//     title: "COMPLETE THE ONBOARDING PROCESS",
//     desc: "The onboarding process includes signing and submitting important documents...",
//     color: "bg-pink-400",
//     iconBg: "bg-pink-400",
//   },
//   {
//     number: "5",
//     title: "KEEP TRACK OF THE CANDIDATE",
//     desc: "We use time-tracking tools to monitor and analyse their performance...",
//     color: "bg-teal-500",
//     iconBg: "bg-teal-500",
//   },
// ];

const ServicesSection = () => {
  const navigate = useNavigate()
  return (
    <section className="py-10">
      <h2 data-aos="fade-up" className="text-[36px] text-center 2xl:text-[40px] lg:text-[32px] font-bold text-[#09588D]  font-recoleta leading-10">
        Smart Staffing Models for Agile Teams
      </h2>
      <div className="lg:max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 lg:px-20">
        </div>
        <div className="hidden lg:block"></div>
        <div className="lg:col-span-1 px-20">
        </div>
      </div>

      <div className="overflow-x-hidden lg:hidden block">
        {servicesData.map((service, index) => (
          <div
            key={service.id}
            className="lg:max-w-7xl lg:w-[85%] 2xl:w-full mx-auto px-4 mt-16 grid lg:grid-cols-12 gap-6 items-center"
          >
            {/* Image */}
            <div className={`lg:col-span-4 ${index % 2 === 0 ? 'lg:order-1' : 'lg:order-3'} order-1`}>
              <img
                src={service.image}
                alt={service.title}
                data-aos="fade-right"
                className="w-full max-w-full h-auto rounded-md"
              />
            </div>

            {/* Number */}
            <div className={`lg:col-span-2 text-center ${index % 2 === 0 ? 'lg:order-2' : 'lg:order-2'} order-2`}>
              <h2 data-aos="fade-left" className="text-[60px] lg:text-[100px] font-stroke text-[#09588D]">
                {service.number}
              </h2>
            </div>

            {/* Text Content */}
            <div className={`lg:col-span-6 ${index % 2 === 0 ? 'lg:order-3' : 'lg:order-1'} order-3`}>
              <h3
                data-aos="fade-left"
                className="font-semibold mb-2 text-[#09588D] text-[24px] lg:text-[32px] font-recoleta px-4 lg:px-0"
              >
                {service.title}
              </h3>

              {[service.description1, service.description2, service.description3, service.description4].map(
                (desc, i) =>
                  desc && (
                    <p
                      key={i}
                      data-aos="fade-left"
                      className="text-gray-700 font-recoleta text-[20px] lg:text-[16px] 2xl:text-[20px] px-4 lg:px-0 mt-2"
                    >
                      {desc}
                    </p>
                  )
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="hidden lg:block">
        {servicesData.map((service, index) => (
          <div
            key={service.id}
            className="lg:max-w-7xl lg:w-[85%] 2xl:w-full mx-auto px-4 mt-16 grid lg:grid-cols-12 gap-6 items-center"
          >
            {/* Image */}
            <div className={`lg:col-span-4 ${index % 2 === 0 ? 'lg:order-1' : 'lg:order-3'} order-1`}>
              <img
                src={service.image}
                alt={service.title}
                data-aos="fade-right"
                className="w-full max-w-full h-auto rounded-md"
              />
            </div>

            {/* Number */}
            <div className={`lg:col-span-2 text-center ${index % 2 === 0 ? 'lg:order-2' : 'lg:order-2'} order-2`}>
              <h2 data-aos="fade-left" className="text-[60px] lg:text-[100px] font-stroke text-[#09588D]">
                {service.number}
              </h2>
            </div>

            {/* Text Content */}
            <div className={`lg:col-span-6 ${index % 2 === 0 ? 'lg:order-3' : 'lg:order-1'} order-3`}>
              <h3
                data-aos="fade-left"
                className="font-semibold mb-2 text-[#09588D] text-[24px] lg:text-[32px] font-recoleta px-4 lg:px-0"
              >
                {service.title}
              </h3>

              {[service.description1, service.description2, service.description3, service.description4].map(
                (desc, i) =>
                  desc && (
                    <p
                      key={i}
                      data-aos="fade-left"
                      className="text-gray-700 font-recoleta text-[20px] lg:text-[16px] 2xl:text-[20px] px-4 lg:px-0 mt-2"
                    >
                      {desc}
                    </p>
                  )
              )}
            </div>
          </div>
        ))}
      </div>



      <div className="lg:w-[80%] lg:max-w-6xl mx-auto py-10 px-4 font-recoleta">
        <h1 className="text-center font-bold text-[#09588D] text-[55px] 2xl:text-[40px] lg:text-[32px] px-4">
          STAFFING PROCESS WE FOLLOW
        </h1>
        <p className="text-center font-semibold  text-[45px] 2xl:text-[26px] lg:text-[20px] px-4 mt-4">
          For smooth, hassle-free and efficient operations we execute and monitor well versed strategy and effective process
        </p>
        <div className="flex justify-center justify-self-center items-center mt-8 rounded-full bg-white shadow lg:w-[260px] w-[400px] lg:h-[40px] h-[50px]">
          <button onClick={() => navigate('/Staffing-Solution-Process')} className="bg-[#09588D] text-white rounded-full w-full h-full text-center 2xl:text-[20px] lg:text-[16px] text-[30px]">
            Check Complete Process
          </button>
        </div>
      </div>
    </section >
  );
};

export default ServicesSection;
